import { ABTestInputCondition, abTestGlobalKey } from '../abtestV2'

export enum SocialProofVariantKey {
  Control = 'control',
  Purchase = 'treatment_purchase', // V1: 128 people bought this week
  Cart = 'treatment_cart', // V2: In 23 carts right now
  Authority = 'treatment_authority', // V3: Best seller in kids drinkware
  Combo = 'treatment_combo', // Step 2 Combo: Purchase + Authority
}

export const PDP_SOCIAL_PROOF_EXPERIMENT_CAMPAIGN: ABTestInputCondition = {
  code: 'pdp_social_proof_campaign',
  exprId: 'pdp_social_proof_experiment',
  exprName: 'PDP Social Proof ATC Experiment',

  startDate: '2026-09-01T00:00:00Z',
  stopDate: '2026-12-31T23:59:59Z',
  endDate: '2026-12-31T23:59:59Z',

  endIfPurchased: false,

  trafficRate: 1,
  variants: [
    { code: SocialProofVariantKey.Control, rate: 0.25 },
    { code: SocialProofVariantKey.Purchase, rate: 0.25 },
    { code: SocialProofVariantKey.Cart, rate: 0.25 },
    { code: SocialProofVariantKey.Authority, rate: 0.25 },
  ],

  allowedDevices: [],
  allowedCountries: [],
  allowedStores: [],
  allowedUrls: [
    'custom-any-photo-personalized-kid-custom-shaped-acrylic-plaque-10589270226scl1tmn1tr04ha07an01hsp1_ipatukid00476',
    'dad-level-unlocked-funny-gaming-father-t-shirt-and-hoodie-01092021025clo2cle1mt01ds01id01tsh1fth5012a-1',
    'custom-any-photo-forever-missed-personalized-memorial-acrylic-led-night-light-10189060326scl1cle1tu08ha07ha12anl1_ipatudth00261',
    'custom-any-photo-personalized-birthday-custom-shaped-acrylic-plaque-10277270226scl1cle1ph08ph01an01hsp1_ipatubid00013',
    'galaxy-and-western-buddy-toy-personalized-movie-for-kids-premium-faux-fur-pillow-10628080626scl1tmn1ph08nh02tr18fsp2_ipatutsy00048',
    'youve-got-a-friend-in-me-personalized-autism-awareness-blanket-10692180626scl1tmn1tr04th07th12blk1_ipatuats00245',
    'custom-any-photo-personalized-blue-dog-custom-shaped-acrylic-plaque-10416260226scl1tmm1tr04ha07an01hsp1_ipatubly00043',
    'custom-any-photo-perfect-birthday-gift-personalized-birthday-custom-shaped-acrylic-plaque-10683250226scl1cle1ph08ha07ha12hsp1_ipatubid00005',
    'funny-mouse-wash-dishes-personalized-mouse-dishwasher-cover-10922140726scl1tmn1tr04nh02li09dwc1_ipatudsn22663',
    'you-me-we-got-this-personalized-couple-tumbler-10431250726scl1cle1tr04cu03du10tbl1_ipatucpl01231',
    'custom-any-photo-birthmonth-flower-personalized-self-love-bookshelf-lamp-10673110826scl1cle1ph08nh02tr15bsl1_ipatuslv00141',
    'custom-from-any-photo-personalized-mother-custom-shaped-acrylic-plaque-10127120226scl1cle1tr04ha07my04hsp1_ipatumth00632',
    'the-little-racer-personalized-racing-lover-premium-faux-fur-pillow-10726160726scl1tmn1tr04ha07li09fsp2_ipatucsm00009',
    'custom-from-any-photo-personalized-memorial-faux-fur-shaped-pillow-10101130126scl1cle1tu08cu03my04fsp1_ipatudth00179',
    'custom-any-photo-you-me-personalized-couple-acrylic-led-night-light-10108160126scl1cle1tr04nh02ha12anl1_ipatucpl00928',
    'laundry-today-personalized-mouse-storage-basket-10436150626scl1tmn1tr04ha08an01lbk1_ipatudsn22485',
    'custom-photo-alphabet-any-theme-personalized-kid-changeable-leather-patch-backpack-10359100726scl1cle1tr04nh02tr15sbp1_ipatukid00813',
    'the-little-racer-personalized-racing-lover-acrylic-display-box-10944280726scl1tmn1tr04cu03tr15acd1_ipatucsm00020',
    'your-wings-were-ready-personalized-memorial-wooden-floating-shelf-10108230626scl1cle1tu08nh02du10wfs1_ipatudth00356',
    'custom-any-photo-birthday-gift-personalized-birthday-custom-shaped-acrylic-plaque-10625240326scl1cle1ph08nh02ha12hsp1_ipatubid00024',
    'autism-support-cartoon-puzzle-toy-personalized-autism-awareness-custom-shaped-acrylic-plaque-10871110326scl1tmn1tr04nh02tr18hsp1_ipatuats00192',
  ],
}
